<div class="rewards-container" [@listAnimation]="rewards.length">
    <div *ngFor="let reward of rewards" 
         class="reward-card"
         [class.unlocked]="reward.unlocked"
         (click)="claimReward(reward)">
        <div class="reward-icon">
            <i [class]="reward.icon"></i>
        </div>
        <div class="reward-info">
            <h3>{{reward.name}}</h3>
            <p>{{reward.description}}</p>
            <div class="progress-bar">
                <div class="progress" 
                     [style.width.%]="(reward.progress / reward.requirements.value) * 100">
                </div>
            </div>
        </div>
    </div>
</div>